import { showCustomSwal } from "../../components/customswal/Customswal";
import Hexapi from "../../utility/HexAPI/Hexapi";
import { showConfirm } from "../../utility/showconfirm";

const safeSplitParams = (queryString) =>
  queryString ? queryString.split("&") : [];


const getParamAt = (arr, idx, fallback = "") =>
  arr?.[idx]?.split("=")?.[1] ?? fallback;

const handleurlqueryexec = async (href, openmodal) => {

  try {
    openmodal(true)
    const params = new URLSearchParams(href.split("?")[1]);
    let query = params.get("query");

    const obj = {
      query: `${query}`,
      queryArr: []
    };
    const resp = await Hexapi(obj)
    console.log(resp,"resp")
    if (resp?.[""]?.length > 0) {
      const { command, msg } = resp[""][0];
        showConfirm({
          content: msg,
          hideCancel: true
        }).then(()=>{
          openmodal(false)
        })
      
    } else {
      showConfirm({
        content: `Unexpected response structure`,
        hideCancel: true
      });
    }
  } catch (error) {
    console.error(error);
     if(error.message =="SQL Error occurred"){
      showCustomSwal("Error occurred please try again")
    }
     openmodal(false)
  } finally {
    openmodal(false)
  }
};

const handleviewopen = async (str, url,openmodal,setattachmentdata) => {

  openmodal(true)
  try {
    const fileParts = str && str?.split('.');
    const fileExt =  str && '.' + fileParts?.at(-1);
    const fileName =  str && fileParts?.slice(0, -1)?.join('.');

    let attachmentId = null;
    const params = new URLSearchParams(url.split("?")[1]);
    attachmentId = params.get("attachmentids");
console.log(attachmentId,"attachmentId")
    if (attachmentId) {
      console.log("dgdhd")
        setattachmentdata({
          attachmentId:attachmentId,
          filename:fileName,
          fileext:fileExt
        });
    }
    openmodal(false)
  } catch (error) {
    console.log(error,"error")
  }
};
export const getlinks = (navigate, href,openmodal,setattachmentdata,text,setismeeting,setmeetinginfo,setQuickAction) => {
  console.log(href,"href")
const prefix="hextrackhr://www.trackhr.com/"

  let route = "none";

  if (href.includes("sourcequery")) {
    let queryParams = safeSplitParams(href?.split("?")[1]);

    if (queryParams.length) {
      let sourcequery = getParamAt(queryParams, 0);
      let name = getParamAt(queryParams, 1);
      let filter = getParamAt(queryParams, 2);

      let encodedParams = btoa(
        `name=${name}&sourcequery=${sourcequery}&filter=${filter}`
      );
      route = `/dynamicreport?${encodedParams}`
    }
  }
 else if (href.includes(`${prefix}AddTeam`)) {
    // setQuickAction({ type: "AddTeam" });
    return;
  }

  else if (href.includes(`${prefix}AddActivity`)) {
   
    setQuickAction({ type: "AddActivity" });
    return;
  }

  else if (href.includes(`${prefix}AddKPI`)) {
    setQuickAction({ type: "AddKPI" });
    return;
  }

  else if (href.includes(`${prefix}AddTicket`)) {
    setQuickAction({ type: "AddTicket" });
    return;
  }
else if (href.includes(`${prefix}AIChatbot`)) {
    console.log("ai chatbot link clicked")
    console.log(decodeURIComponent(href),"hrefffff")
    const params = safeSplitParams(href.split("?")[1]);
const data=`${decodeURIComponent(getParamAt(params, 0))}`
console.log(data)
window.postMessage(
    { type: "DEFQUES",  data},
    "*"
  );
    route = `/novachatbot`;

  }

else if(href.includes(`${prefix}ActivitiesList`)){
  const paramString = href.split("?")[1];
  console.log(paramString,"params")
  const params = safeSplitParams(paramString);
  route = `/activity?${btoa(
    `id=${getParamAt(params, 0)}&name=${getParamAt(params, 1)}`
  )}`;
}
else if(href.includes(`${prefix}TicketList`)){
  const paramString = href.split("?")[1];
  console.log(paramString,"params")
  const params = safeSplitParams(paramString);
  route = `/tickets?${btoa(
    `id=${getParamAt(params, 0)}&name=${getParamAt(params, 1)}`
  )}`;
}

  else if (href.includes(`${prefix}WorkHistory`)) {
    const params = safeSplitParams(href.split("?")[1]);
    route = `/workhistory?${btoa(
      `id=${-1}&name=${getParamAt(params, 1)}&shiftid=${getParamAt(params, 0)}`
    )}`;

  } else if (href.includes(`${prefix}Activity`)) {
    const params = safeSplitParams(href.split("?")[1]);
    route = `/activityhistory?${btoa(
      `id=${-1}&page=activityhistory&activityid=${getParamAt(params, 0)}`
    )}`;

  } else if (href.includes(`${prefix}Ticket`)) {
    const params = safeSplitParams(href.split("?")[1]);
    route = `/tickets?${btoa(
      `id=${-1}&tid=${getParamAt(params, 0)}&name=${-1}`
    )}`;

  } else if (href.includes(`${prefix}RedFlag`)) {
    const params = safeSplitParams(href.split("?")[1]);
    route = `/redflag?${btoa(
      `id=${getParamAt(params, 0)}&name=${-1}`
    )}`;

  } else if (href.includes(`${prefix}UserProfile`)) {
    const params = safeSplitParams(href.split("?")[1]);
    route = `/profile?${btoa(
      `id=${getParamAt(params, 0)}&page=Userprofile`
    )}`;

  } else if (href.includes(`${prefix}EmpLeaves`)) {
    const params = safeSplitParams(href.split("?")[1]);
    route = `/leaves?${btoa(
      `id=${getParamAt(params, 0)}&name=${getParamAt(params, 1)}`
    )}`;

  } else if (href.includes(`${prefix}EmpApprovals`)) {
    const params = safeSplitParams(href.split("?")[1]);
    route = `/approvals?${btoa(
      `approvaltype=${getParamAt(params, 0)}&approvalstage=${getParamAt(params, 1)}`
    )}`;

  } else if (href.includes(`${prefix}TicketList`)) {
    route = `/tickets`;

  }

  else if (href.includes(`${prefix}EmpTimeline`)) {
    const params = safeSplitParams(href.split("?")[1]);
    route = `/locationtimeline?${btoa(
      `id=${getParamAt(params, 0)}&shiftid=${getParamAt(params, 2)}&name=${getParamAt(params, 1)}`
    )}`;
  }

  else if (href.includes(`${prefix}LeaderboardReport`)) {
    route = `/leaderboard?${btoa(`IsShowArrow=true`)}`;
  }
  else if (href.includes("Home")) {
    route = `/home`;

  }

  else if (href.includes(`${prefix}ViewAttachment`)) {
    handleviewopen(text,href,openmodal,setattachmentdata)
    return
  }
  else if (href.includes(`${prefix}KPIPendencyList`)) {
console.log(href,"KPIPendencyList")
    const paramString = href.split("?")[1]
    const params = safeSplitParams(paramString);
    route = `/kpipendency?${btoa(
      `id=${getParamAt(params, 0)}&isShowArrow=true&username=${getParamAt(params, 1)}`
    )}`;

  }
  else if (href.includes(`${prefix}KPIPendency`)) {
    const params = safeSplitParams(href.split("?")[1]);
    route = `/kpipendency?${btoa(`kpiid=${getParamAt(params, 0)}&IsShowArrow=true`)}`;
  }
  else if (href.includes(`${prefix}KPI`)) {
    const params = safeSplitParams(href.split("?")[1]);
    route = `/kpidetails${btoa(`id=${-1}&kpiid=${getParamAt(params, 0)}&IsShowArrow=true`)}`;
  }
  else if (href.includes(`${prefix}ToDoList`)) {
    const params = safeSplitParams(href.split("?")[1]);
    console.log(`id=${getParamAt(params, 0)}&name=${getParamAt(params, 1)}`,"dfwyuyiso")
    route = `/todo?${btoa(`id=${getParamAt(params, 0)}&name=${getParamAt(params, 1)}`)}`;
  }

  else if (href.includes(`${prefix}urlqueryexec`)) {
    handleurlqueryexec(href, openmodal)
    return;
  } else if (href.includes(`${prefix}Meeting`)) {
    const params = safeSplitParams(href.split("?")[1]);
    route = `/meetings?${btoa(`meetingid=${getParamAt(params, 0)}`)}`;

    // showConfirm({
    //   content: "Use mobile app to execute this action.",
    //   hideCancel: true
    // })
    // return;
  } else if (href.includes(`${prefix}ManagerQRScan`)) {
    showConfirm({
      content: "Use mobile app to execute this action.",
      hideCancel: true
    })
    return;
  } else if (href.includes(`${prefix}AddMeeting`)) {

    //  const params = href.split("?")[1].split("&");
    const queryString = href.split("?")[1];
const urlParams = new URLSearchParams(queryString);

const meetdata = {
  empids: urlParams.get("empids"),
  scheduledtime: urlParams.get("scheduledtime"),
  name: urlParams.get("name"),
  description: urlParams.get("description"),
  location: urlParams.get("location"),
  categoryid: urlParams.get("categoryid"),
  gmeetenabled: urlParams.get("gmeetenabled"),
};
    setismeeting(true)
    setmeetinginfo(meetdata)
    // showConfirm({
    //   content: "Use mobile app to execute this action.",
    //   hideCancel: true
    // })
    return;
  }
  if (route !== "" && route != "none") {
    navigate(route)
  }
}